import { CheckBoxSwitcher, FormInput, InputProps, BinIcon } from '@systemeio/ui'
import ItemWrapper from 'modules/stores/store/components/item-wrapper'
import { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { InitFieldsInterface } from '..'

interface StoreFieldProps extends Omit<InputProps, 'id'> {
  isRequired: boolean
  slug: string
  onChangeRequired: (value: boolean) => void
  onDelete: (slug: string) => void
  initFields?: InitFieldsInterface[]
}

const StoreField: FC<StoreFieldProps> = ({
  isRequired,
  onChangeRequired,
  onDelete,
  slug,
  initFields,
  ...rest
}) => {
  const { t } = useLocoTranslation()
  const isMandatory = initFields?.find(initField => initField.slug === slug)?.mandatory ?? false

  return (
    <ItemWrapper id={slug} className={'items-end'} iconClassName={'mb-[8.5px]'}>
      <FormInput
        {...rest}
        disabled={true}
        required={isRequired}
        inputClassName={'w-full'}
        className={'w-full'}
        addonAfter={
          !isMandatory && (
            <div className={'flex items-center gap-3'}>
              <CheckBoxSwitcher
                wrapperClassName={'flex-row'}
                label={t('dashboard.store.item.required')}
                selected={isRequired}
                onChange={onChangeRequired}
              />
              <button onClick={() => onDelete(slug)} className={'group'}>
                <BinIcon
                  className={
                    'group-hover:fill-danger group-focus-visible:fill-danger main-transition-colors h-[20px] w-[20px]'
                  }
                />
              </button>
            </div>
          )
        }
      />
    </ItemWrapper>
  )
}

export default StoreField
